<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box no-display">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Timesheet Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <span class="small-text"><b>Section</b></span
            ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
            <v-autocomplete
              color="#0F2027"
              dense
              required
              v-model="section"
              item-value="id"
              outlined
              class="mt-1"
              item-color="indigo"
              :items="all_section_list"
              @change="EmpSectionChange()"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <span class="small-text"><b>Employee Type</b></span
            ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
            <v-autocomplete
              color="#0F2027"
              dense
              required
              v-model="empType"
              item-value="id"
              outlined
              item-color="indigo"
              class="mt-1"
              @change="EmpTypeChange()"
              :items="all_employee_type_list"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <span class="small-text"><b>Shift</b></span
            ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
            <v-autocomplete
              color="#0F2027"
              dense
              required
              v-model="empShift"
              item-value="id"
              outlined
              class="mt-1"
              item-color="indigo"
              @change="getEmployeesForTimesheet(section,empType,empShift)"
              :items="all_emp_shift_list"
              item-text="name"
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <span class="small-text"><b>Teacher</b></span
            ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
            <v-autocomplete
              color="#0F2027"
              dense
              required
              v-model="inst"
              item-value="id"
              outlined
              class="mt-1"
              item-color="indigo"
              :items="inst_list"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <span class="small-text"><b>Report Type</b></span
            ><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
            <v-autocomplete
              color="#0F2027"
              dense
              required
              v-model="report"
              item-value="id"
              outlined
              item-color="indigo"
              class="mt-1"
              :items="report_type_list"
              item-text="name"
            />
          </v-col>
        </v-row>
        <v-row align="center" justify="center" dense>
          <span class="mb-2"><b>Period</b></span>
          <v-icon class="pl-1 pb-5" small color="error">*</v-icon>
          <v-radio-group v-model="date" mandatory row>
            <v-radio label="Today" :value="false" color="orange darken-3" class="ml-7 small-text"></v-radio>
            <v-radio label="Date Range" :value="true" color="orange darken-3"></v-radio>
          </v-radio-group>
        </v-row>
        <v-row dense justify="center">
        <v-col cols="12" sm="2" md="2" v-if="this.date == true">
          <b class="small-text">From Date</b>
          <v-icon class="pl-1 pb-2" small color="error">*</v-icon>
          <v-text-field
            outlined
            dense
            type="date"
            v-model="fromdate"
            hint="(Inclusive)"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="this.date == true">
          <b class="small-text">To Date</b>
          <v-icon class="pl-1 pb-2" small color="error">*</v-icon>
          <v-text-field
            outlined
            dense
            type="date"
            v-model="todate"
            hint="(Inclusive)"
            persistent-hint
          ></v-text-field
        > </v-col>
    </v-row>  

        <v-row justify="center" class="mt-3">
            <v-btn class="white-text" color="cyan" :loading="loader" tile small @click="getReport()"
              >Fetch Report</v-btn
            >
        </v-row>
      </v-card>

        <v-card class="outer" v-if="timesheet_report_list.length > 0">
            <v-data-table :headers="headers" :items="formattedTimesheetReportList" id="my-table-id" class="elevation-1 mytable padding" :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-spacer></v-spacer>
                        <v-text-field class="" v-model="search" background-color="white"  append-icon="mdi-magnify" label="Search" style="margin-left: 200px;"
                        single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
            </v-data-table>
        </v-card>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    search: "",
    section: null,
    empShift: null,
    empType: null,
    inst: null,
    report: null,
    color: "",
    snackbar: false,
    overlay: false,
    all_section_list: [],
    all_emp_shift_list: [],
    all_employee_type_list: [],
    timesheet_report_list:[],
    inst_list:[],
    report_type_list : [
      { "id" : null, "name": "All" },
      { "id" : 1, "name": "Filled" },
      { "id" : 2, "name": "Not Filled"}
    ],
    date: false,
    fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2)
      .toISOString()
      .substr(0, 10),
    todate: new Date().toISOString().slice(0, 10),
    headers: [
      {
        text: "Sr. No.",
        align: "center",
        value: "sr_no",
      },
      {
        text: "Teacher",
        align: "center",
        value: "instructor",
      },
      {
        text: "Date",
        align: "center",
        value: "date",
      },
      {
        text: "Start Time",
        align: "center",
        value: "start_time",
      },
      {
        text: "End Time",
        align: "center",
        value: "end_time",
      },
      {
        text: "Task",
        align: "center",
        value: "task",
      },
      {
        text: "Description",
        align: "center",
        value: "description",
      },
    ],
  }),
  computed: {
    formattedTimesheetReportList() {
      return this.timesheet_report_list.map(item => ({
        ...item,
        date: this.formatDate(item.date)
      }));
    }
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //     type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
        if (dateStr.includes(" to ")) {
        return dateStr.split(" to ")
          .map(date => this.formatSingleDate(date))
          .join(" to ");
      } else {
        return this.formatSingleDate(dateStr);
      }
    },
    formatSingleDate(dateStr) {
      const [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    },
    getReport() {
      if (this.section === "" || this.empType === "" || this.empShift === "" || this.report === "" || this.inst === "") {
        this.showSnackbar("error", "Please fill all required fields !!!");
        return;
      }
      this.loader = true;
      const instIds = this.inst === null 
        ? this.inst_list.filter(item => item.id !== null).map(item => item.id) 
        : [this.inst]; 

      const data = {
        section: this.section,
        empShift: this.empShift,
        empType: this.empType,
        inst: instIds, 
        report: this.report,
        date: this.date,
        fromdate: this.date ? this.fromdate : null,
        todate: this.date ? this.todate : null,
      };

      axios
        .post("/Timesheet/fetchTimesheetReport", data)
        .then((res) => {
          if (res.data.flag === "YES") {            
            this.timesheet_report_list = res.data.timesheet_report_list;
            this.loader = false;
          } else if (res.data.flag === "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.loader = false;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        });
    },
    onLoad() {
      axios
        .post("/Timesheet/getTimesheetInitData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.all_employee_type_list = res.data.all_employee_type_list;
            this.all_emp_shift_list = res.data.all_emp_shift_list;
            this.all_section_list = res.data.all_section_list;
            this.inst_list = res.data.inst_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    getEmployeesForTimesheet(section_id,empType_id,empShift_id) {
      const data = {
        section_id: section_id,
        empType_id : empType_id,
        empShift_id : empShift_id
      };
      this.overlay = true;
      axios
        .post("/Timesheet/getEmployeesForTimesheet", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_list = res.data.inst_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", "something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          } else {
            this.showSnackbar("red","something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    EmpTypeChange(){
      this.empShift = "";
      this.inst = "";
    },
    EmpSectionChange(){
      this.empType = "";
      this.empShift = "";
      this.inst = "";
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
.small-text {
  font-size: 14px;
}
.white-text{
    color: white;
}
.outer {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid lightgray !important;

}
tr,
td,
th {
  border: 1px solid #ccc;
  width: auto;
  font-size: small;
}

@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .box {
    background-color: white !important;
    border: none !important;
  }
}
</style>
